// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1zMpx","fileBtn":"File_fileBtn__2aiuo","closeBtn":"File_closeBtn__1YCgZ","fileSelected":"File_fileSelected__1pSew","disabled":"File_disabled__2ACEn"};